import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  ReorderEstimateLineItemsMutation as ReorderEstimateLineItemsMutationResult,
  Scalars,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { hydrateEstimateCaches } from './hydrateEstimateCaches';

const ReorderEstimateLineItemsMutation = graphql(`
  mutation ReorderEstimateLineItems($sectionId: ID!, $lineItemIds: [ID!]!) {
    reorderEstimateLineItems(sectionId: $sectionId, lineItemIds: $lineItemIds) {
      ...EstimateBuilderEstimate
      preview {
        template
        context
      }
    }
  }
`);

type Variables = {
  sectionId: Scalars['ID']['input'];
  lineItemIds: Array<Scalars['ID']['input']>;
};

const useReorderEstimateLineItems = (args: {
  projectId: string;
  estimateId: string;
  options?: UseMutationOptions<
    ReorderEstimateLineItemsMutationResult,
    Error,
    Variables
  >;
}) => {
  const { projectId, estimateId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation<ReorderEstimateLineItemsMutationResult, Error, Variables>({
    mutationFn: ({ sectionId, lineItemIds }) => {
      return gqlClient.request(ReorderEstimateLineItemsMutation, {
        sectionId,
        lineItemIds,
      });
    },
    onSuccess: (data, variables, context) => {
      hydrateEstimateCaches(queryClient, {
        projectId,
        estimateId,
        estimate: data.reorderEstimateLineItems,
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useReorderEstimateLineItems;
